import api from '../api';

/**
 * This function formats total seconds in workout mints eg.1h 30m
 * */
function getWorkoutMin(totalSeconds) {
    let hours = Math.floor(totalSeconds / 60 / 60);
    let minutes = Math.floor(totalSeconds / 60) - (hours * 60);
    let workoutMinStr = "";
    if (hours) {
        workoutMinStr += hours + "h ";
    }
    workoutMinStr += minutes + "m";
    return workoutMinStr;
}

function capitalize(word) {
    return word.toString()
        .trim()
        .split(' ')
        .map((str) => {
            const lower = str.toLowerCase();
            return str.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join(' ')
}

const state = {
    loading: true,
    allTeamsObj: {},
    usersList:false,
    leaderboard: [],
    viewAllActive : false,
    teamName: null,
    filters: {
        fromDate: '',
        toDate: '',
        teamNames: '',
        sortBy: 'workoutMin',
        sortDesc: true,
        selectedTeams: []
    },
    allTeams: [],
    isAdmin: false,
    org: '',
    teamID: null,
    mainTeamsLoading: false,
    mainInterTeamLoading: false,
    mainAllTeamsLeaderboard: [],
    mainInterTeamLeaderboard: [],
}

const mutations = {

    setTeamID(state, data) {
        state.teamID = data;
    },

    setLeaderboardData(state, data) {
        state.allTeams = data?.allTeams;
        state.allTeamsObj = data?.allTeamsObj;
        state.leaderboard = data?.leaderboard;
        state.mainAllTeamsLeaderboard = data?.leaderboard;
        state.mainInterTeamLeaderboard = data?.myInterTeam;
    },
    setUserListShow(state, data){
        state.usersList = data;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setTeamName(state, teamName){
        state.teamName = teamName
    },
    setViewAllActive(state, bool){
        state.viewAllActive = bool
    },
    setFilters(state, filters) {
        state.filters = filters;
    },
    setIsAdmin(state, isAdmin) {
        state.isAdmin = isAdmin;
    },
    getOrg(state, org) {
        state.org = org;
    },
};

const actions = {

    async loadLeaderBoardData({commit, state, rootState}) {
        commit("setLoading", true)
        let userData = rootState.userInfo
        let org = state.org;
        if (org === '' && userData?.corporate?.organization) {
            org = userData.corporate.organization
        }
        // Add filter in request for admin (Corporate HR) Users
        let filters = state.isAdmin ? state.filters : undefined;
        let data = await api.getLeaderBoard(org, { filters });
        if (data.code && data.code === 200) {
            commit("setLeaderboardData", data.data);
            commit("setUserListShow", data.usersList);
            if (data.filters) {
                commit("setFilters", data.filters);
            }
        } else {
            commit("setUserListShow", false);
            commit("setLeaderboardData", []);
        }
        commit("setLoading", false);
    },

    async updateFilters({ state, rootState }) {
        let userData = rootState.userInfo
        let data = await api.updateFilter({
            filters: state.filters,
            organization: userData?.corporate.organization
        });
        if (data.code !== 200) {
            alert('Applied Filter not saved');
        }
    },

    setTeamName({commit}, team){
        commit("setViewAllActive", team.isActive);
        commit("setTeamName", team.teamName);
    },

    setFilters({commit}, filter) {
        commit("setFilters", filter);
    },

    setIsAdmin({commit}, isAdmin) {
        commit("setIsAdmin", isAdmin);
    },

    getOrg({commit}, org) {
        commit("getOrg", org);
    }
};

const getters = {
    leaderBoardList(state) {
        return state.allTeamsObj;
    },

    rankedTeams(state) {
        let leaderboard = state.leaderboard;
        const selectedTeams = state.filters.selectedTeams;
        if (selectedTeams && selectedTeams.length) {
            leaderboard = leaderboard.filter((team) => selectedTeams.includes(team.teamName));
        }
        return leaderboard;
    },
    rankedUsers(state) {
        const users = state.allTeamsObj[state.teamName]?.viewAll;
        return users.map((user, index) => {
            return {
                ...user,
                rank: index + 1
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
